import React from 'react';
import styles from './MortgageInPriceBanner.css';

interface IMortgageInPriceBannerProps {
  link: string;
  text: string;
  onClick(e: React.SyntheticEvent<HTMLAnchorElement>): void;
}

export function MortgageInPriceBanner({ link, text, onClick }: IMortgageInPriceBannerProps) {
  return (
    <a data-mark="MortgageSimpleBannerLink" href={link} target={'_blank'} className={styles['link']} onClick={onClick}>
      {text}
    </a>
  );
}
